import {isNil, isEmpty} from '@megaphonenpm/mputils/src/utils.js';
import {ScreenComponent} from "./ScreenComponent.js";
import {fitText, hide, setText, show} from '@megaphonenpm/mputils/src/DOM.js';
import {cloneInstance} from "../GWDService.js";


/**
 * Displays the secondary text in the scene masthead, which typically
 * contains the social userid (e.g., Twitter @name).
 */
export class MastheadSecondaryTextComponent extends ScreenComponent {
  constructor (themeID, visibleProducts) {
    super(themeID, ['secondary_title_txt'], {visibleProducts: visibleProducts });
  }

  validate () {
    super.validate();

    if (isNil(this.visibleProducts)) {
      this.valid = false;
    }
  }

  build () {
    super.build();

    // Pre-flight check
    if (!this.valid) {
      return;
    }

    // Start build
    this.view = cloneInstance(this.themeID, 'secondary_title_txt');

    // Indicate the states and products during which the view should be visible
    this.view.classList.add('state_scene', 'state_scene_result');
    this.visibleProducts.forEach(productName => {
      this.view.classList.add(`product_${productName}`);
    });
  }

  setText (text) {
    if (!this.valid) {
      return;
    }

    // When there's no secondary text to display, hide the #secondary_title_txt <div>
    // entirely so it doesn't take up space among the masthead's flex children.
    if (isEmpty(text)) {
      hide(this.view);
    } else {
      show(this.view);
      this.view.style.removeProperty('font-size');
      setText([this.view], text);
      // TODO: See comment about setTimeout() usage in MastheadMainTextComponent.
      // TODO: Consider centralizing this code with the similar code in MastheadMainTextComponent.
      //   Consolidate into a shared superclass if appropriate.
      setTimeout(() => {
        fitText(this.view, this.view.clientWidth, this.view.clientHeight);
      }, 0);
    }

  }

  reset () {
    this.setText('');
  }
}